import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HomeExternalPqrsComponent } from '../home-external-pqrs/home-external-pqrs.component';
import { StaticData } from '../../../helpers/static-data';

@Component({
  selector: 'app-user-pqrs',
  templateUrl: './user-pqrs.component.html',
  styleUrls: ['./user-pqrs.component.scss']
})
export class UserPqrsComponent {
  @Input() DatosUsuario: string;
  @Input() DatosIngreso: string;
  @Output() ExitEvent = new EventEmitter();
  
  ngOnInit() {
    
  }

  public OnInitEnd()
  {
    debugger;
    /*var data = JSON.parse(StaticData.ExternalPqrContact);
    this.DatosUsuario = data.NombreCompleto + ', ID ' + data.Identificacion + '  |  ';*/
  }

  PqrExit()
  {
    this.ExitEvent.emit();
  }

  UpdateUserData()
  {
    debugger;
    var CurrentUrl = window.location.href;
    window.location.href = CurrentUrl.substr(0, CurrentUrl.lastIndexOf('/')+1) + 'ExternalPQRContact';
  }

}
